export default "__VITE_ASSET__ppucD7f5__"